import { TFunction } from 'react-i18next';
import { GenericObject, Nullable } from '@dxb-web-ui-framework/common/types';
import { FormConfig } from '@dxb-web-ui-framework/content-composer/components/FormBuilder/types';
import { RoutingTransferTypes } from '../../../domain/Transfer/entities/RoutingResponseDTO';
import { TransferServiceImpl } from '../../../domain/Transfer/usecases';
import { ForeCastFormData } from '../../types';
import { BopCode, SwiftCode, VocCode } from '../../../domain/Transfer/entities';
import { FavouriteTransfer } from '../../../domain/FavouriteTransfer/entities';
import {
  internalTransferFormConfig,
  intrabankTransferFormConfig,
  externalTransferFormConfig,
  externalUnknownBankTransferFormConfig,
} from './formConfigs';

const getFormConfigsByTransferType = (
  t: TFunction,
  stepAData: { values: GenericObject },
  service: TransferServiceImpl,
  formData: Nullable<ForeCastFormData>,
  isLoading: boolean,
  selectedBankSwiftCode: Nullable<SwiftCode>,
  bopCodes?: BopCode[],
  vocCodes?: VocCode[],
  isLoadingBopCodes?: boolean,
  isLoadingVocCodes?: boolean,
  isLegalEntity?: boolean,
  favouriteTransfer?: Nullable<FavouriteTransfer>,
  shouldShowPriorityFields?: boolean,
  isSepaRoutingSystem?: boolean,
): FormConfig => {
  switch (stepAData.values.routingResponseData.transferType) {
    case RoutingTransferTypes.INTERNAL_OTHER_CURRENCY:
      return internalTransferFormConfig(
        t,
        stepAData,
        service,
        formData,
        isLoading,
        vocCodes,
        isLoadingVocCodes,
        favouriteTransfer,
      );
    case RoutingTransferTypes.INTRABANK_SAME_CURRENCY:
    case RoutingTransferTypes.INTRABANK_OTHER_CURRENCY:
    case RoutingTransferTypes.CORPORATE_INTERNAL_SAME_CURRENCY:
    case RoutingTransferTypes.CORPORATE_INTERNAL_OTHER_CURRENCY:
      return intrabankTransferFormConfig(
        t,
        stepAData,
        service,
        formData,
        isLoading,
        vocCodes,
        isLoadingVocCodes,
        favouriteTransfer,
      );
    case RoutingTransferTypes.EXTERNAL_SAME_CURRENCY:
    case RoutingTransferTypes.EXTERNAL_OTHER_CURRENCY:
      return externalTransferFormConfig(
        t,
        stepAData,
        service,
        formData,
        isLoading,
        bopCodes,
        vocCodes,
        isLoadingBopCodes,
        isLoadingVocCodes,
        isLegalEntity,
        favouriteTransfer,
        shouldShowPriorityFields,
        isSepaRoutingSystem
      );
    case RoutingTransferTypes.EXTERNAL_UNKNOWN_BANK_SAME_CURRENCY:
    case RoutingTransferTypes.EXTERNAL_UNKNOWN_BANK_OTHER_CURRENCY:
      return externalUnknownBankTransferFormConfig(
        t,
        stepAData,
        service,
        formData,
        isLoading,
        selectedBankSwiftCode,
        bopCodes,
        vocCodes,
        isLoadingBopCodes,
        isLoadingVocCodes,
        isLegalEntity,
        favouriteTransfer,
        shouldShowPriorityFields,
        isSepaRoutingSystem
      );
    default:
      return internalTransferFormConfig(
        t,
        stepAData,
        service,
        formData,
        isLoading,
        vocCodes,
        isLoadingVocCodes,
        favouriteTransfer,
      );
  }
};

export { getFormConfigsByTransferType };
